export function calculateCellLevel(areaSize, rowIndex, columnIndex) {
  let middle = areaSize / 2;
  let maxLevel = (rowIndex < middle ? rowIndex + 1 : areaSize - rowIndex);
  let level = (columnIndex < middle ? columnIndex + 1 : areaSize - columnIndex);
  // console.log('rowIndex ' + rowIndex, 'columnIndex ' + columnIndex);
  // console.log('maxLevel ' + maxLevel, 'level ' + level);

  return level <= maxLevel ? level : maxLevel;
}
